import type { Props } from './Svg'

export function CheckBigIcon(props: Props) {
  return (
    <svg width="79" height="79" fill="none" {...props}>
      <path
        d="M39.5 69.13a29.63 29.63 0 1 0 0-59.26 29.63 29.63 0 0 0 0 59.26Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="m29.63 39.5 6.58 6.58 13.16-13.16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
